import { Action, ActionReducer, createReducer, on } from '@ngrx/store';

import { UnitsActions } from './units.actions';
import { SettingsPreferenceOption, UnitsState } from './units.state';

export const initUnitsState: UnitsState = {
  preferences: {
    notifications: SettingsPreferenceOption.Off,
    temperature: SettingsPreferenceOption.Celsius,
    flowRate: SettingsPreferenceOption.LiterPerHour,
    volume: SettingsPreferenceOption.CubicMeter,
    pressure: SettingsPreferenceOption.Bar,
  },
  setLoading: false,
  getLoading: false,
};

export const unitsReducer: ActionReducer<UnitsState, Action> = createReducer(
  initUnitsState,

  on(
    UnitsActions.getSettingsPreferences,
    (state): UnitsState => ({
      ...state,
      setLoading: false,
      getLoading: true,
    })
  ),

  on(
    UnitsActions.getSettingsPreferencesSuccess,
    (state, { preferences }): UnitsState => {
      const newPreferences = { ...state.preferences };
      Object.keys(preferences).forEach((key) => {
        newPreferences[key] = preferences[key];
      });

      return {
        ...state,
        preferences: newPreferences,
        setLoading: false,
        getLoading: false,
      };
    }
  ),

  on(
    UnitsActions.getSettingPreferencesError,
    (state): UnitsState => ({
      ...state,
      setLoading: false,
      getLoading: false,
    })
  ),

  on(
    UnitsActions.setSettingsPreferences,
    (state): UnitsState => {
      return {
        ...state,
        setLoading: true,
        getLoading: false,
      };
    }
  ),

  on(
    UnitsActions.setSettingsPreferencesSuccess,
    (state, { preferences }): UnitsState => ({
      ...state,
      preferences,
      setLoading: false,
      getLoading: false,
    })
  ),

  on(
    UnitsActions.setSettingsPreferencesError,
    (state): UnitsState => ({
      ...state,
      setLoading: false,
      getLoading: false,
    })
  )
);
